var _g, _circle, _circle2, _g2, _g3, _g4, _g5, _g6, _rect, _path, _path2, _path3, _g7, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWriteWizAlternative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 604,
    viewBox: "0 0 629 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3491_2725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360 267.49H338.983L327.832 304.235L316.427 267.49H298.614L307.457 295.62L317.965 333H337.317L360 267.49Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.832 304.235L316.427 267.496H298.611L307.457 295.625L317.965 333.006H337.317L327.832 304.235Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 267L277.556 332.51H296.907L307.546 295.13L316.516 267H298.704L287.168 303.748L276.017 267H255Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.807 312.859L286.101 312.657L269.096 307.775L277.556 332.51H296.908L301.313 317.04L286.807 312.859Z",
    fill: "url(#paint0_linear_3491_2725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.553 320.862L317.966 333H337.317L339.067 327.948L314.553 320.862Z",
    fill: "url(#paint1_linear_3491_2725)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.557 267.826C347.846 270.112 346.308 272.063 344.236 273.309C342.163 274.555 339.699 275.011 337.308 274.59C336.926 274.524 336.857 274.519 336.842 274.59C336.828 274.661 336.906 274.681 337.401 274.841C339.749 275.572 341.73 277.15 342.949 279.258C344.123 281.254 344.539 283.595 344.123 285.865C344.048 286.281 344.045 286.347 344.106 286.364C344.166 286.381 344.192 286.321 344.308 285.956C345.005 283.681 346.52 281.734 348.57 280.479C350.62 279.225 353.064 278.749 355.444 279.141C355.933 279.215 356.023 279.218 356.023 279.161C356.023 279.104 355.977 279.076 355.609 278.962C353.291 278.257 351.313 276.743 350.048 274.704C348.784 272.665 348.319 270.241 348.742 267.889C348.809 267.513 348.812 267.45 348.742 267.436C348.673 267.422 348.664 267.464 348.557 267.826Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 300,
    r: 299.5,
    stroke: "#A5A5A5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 300,
    r: 199.5,
    stroke: "#A5A5A5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3491_2725)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    transform: "translate(585 238)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.369 265.747C594.369 268.267 592.314 270.325 589.794 270.325C587.274 270.325 585.217 268.267 585.217 265.747C585.217 263.227 587.275 261.169 589.795 261.169H594.369L594.369 265.747ZM596.675 265.747C596.675 263.227 598.733 261.169 601.253 261.169C603.773 261.169 605.831 263.227 605.831 265.747V277.206C605.831 279.726 603.773 281.784 601.253 281.784C598.733 281.784 596.675 279.726 596.675 277.206V265.747Z",
    fill: "#DE1C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.253 247.369C598.733 247.369 596.675 245.314 596.675 242.794C596.675 240.274 598.733 238.217 601.253 238.217C603.773 238.217 605.831 240.275 605.831 242.794V247.369L601.253 247.369ZM601.253 249.675C603.773 249.675 605.831 251.733 605.831 254.253C605.831 256.773 603.773 258.831 601.253 258.831H589.794C587.274 258.831 585.217 256.773 585.217 254.253C585.217 251.733 587.275 249.675 589.795 249.675H601.253Z",
    fill: "#35C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.632 254.253C619.632 251.733 621.687 249.675 624.207 249.675C626.726 249.675 628.784 251.733 628.784 254.253C628.784 256.773 626.726 258.831 624.207 258.831H619.632V254.253ZM617.325 254.253C617.325 256.773 615.267 258.831 612.748 258.831C610.228 258.831 608.17 256.773 608.17 254.253V242.794C608.17 240.274 610.228 238.217 612.748 238.217C615.267 238.217 617.325 240.275 617.325 242.794V254.253Z",
    fill: "#2EB57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.748 272.631C615.267 272.631 617.325 274.686 617.325 277.206C617.325 279.726 615.267 281.784 612.748 281.784C610.228 281.784 608.17 279.726 608.17 277.206V272.631H612.748ZM612.748 270.325C610.228 270.325 608.17 268.267 608.17 265.747C608.17 263.227 610.228 261.169 612.748 261.169H624.207C626.726 261.169 628.784 263.227 628.784 265.747C628.784 268.267 626.726 270.325 624.207 270.325H612.748Z",
    fill: "#EBB02E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3491_2725)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 29.3333,
    transform: "translate(0 390)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 419.189V404.156L4.72777 399.891L0 397.524V416.536C0 418.004 1.34492 419.189 3.00008 419.189H10Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 419.189H41C42.6601 419.189 44 417.999 44 416.536V397.524L38.6451 400.235L34 404.156V419.189Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99963 404.156L9.28223 398.282L9.99963 392.66L21.9996 400.619L33.9996 392.66L34.8021 397.979L33.9996 404.156L21.9996 412.115L9.99963 404.156Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 392.661V404.157L44 397.524V393.987C44 390.707 39.765 388.837 36.8002 390.804L34 392.661Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 397.524L4.5992 400.574L10 404.156V392.66L7.19984 390.803C4.22984 388.836 0 390.706 0 393.987V397.524V397.524Z",
    fill: "#C5221F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3491_2725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 237C146 224.85 136.15 215 124 215C111.85 215 102 224.85 102 237C102 247.981 110.045 257.082 120.562 258.733V243.359H114.977V237H120.562V232.153C120.562 226.639 123.847 223.594 128.872 223.594C131.279 223.594 133.797 224.023 133.797 224.023V229.437H131.023C128.29 229.437 127.438 231.133 127.438 232.873V237H133.539L132.564 243.359H127.438V258.733C137.955 257.082 146 247.981 146 237Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.564 243.359L133.539 237H127.438V232.873C127.438 231.133 128.29 229.438 131.023 229.438H133.797V224.023C133.797 224.023 131.279 223.594 128.872 223.594C123.847 223.594 120.562 226.639 120.562 232.153V237H114.977V243.359H120.562V258.733C121.7 258.911 122.849 259 124 259C125.151 259 126.3 258.911 127.438 258.733V243.359H132.564Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3491_2725)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 36.6667,
    transform: "translate(471 353)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 357.465C513.352 358.21 511.605 358.699 509.815 358.916C511.679 357.775 513.11 355.97 513.784 353.818C512.012 354.891 510.074 355.648 508.052 356.054C506.405 354.263 504.059 353.144 501.463 353.144C496.478 353.144 492.436 357.27 492.436 362.358C492.436 363.08 492.515 363.784 492.669 364.458C485.167 364.074 478.515 360.406 474.063 354.831C473.286 356.192 472.841 357.775 472.841 359.463C472.841 362.66 474.435 365.48 476.857 367.133C475.423 367.087 474.021 366.692 472.768 365.98C472.767 366.019 472.767 366.057 472.767 366.096C472.767 370.56 475.879 374.285 480.008 375.131C478.679 375.5 477.285 375.554 475.932 375.289C477.081 378.95 480.414 381.613 484.364 381.688C481.275 384.159 477.383 385.632 473.153 385.632C472.425 385.632 471.706 385.589 471 385.504C474.995 388.118 479.74 389.643 484.838 389.643C501.442 389.643 510.522 375.603 510.522 363.427C510.522 363.027 510.513 362.63 510.496 362.235C512.263 360.931 513.788 359.315 515 357.465Z",
    fill: "#55ACEE"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3491_2725)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    transform: "translate(233 469)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.688 469H243.312C237.617 469 233 473.617 233 479.312V502.688C233 508.383 237.617 513 243.312 513H266.688C272.383 513 277 508.383 277 502.688V479.312C277 473.617 272.383 469 266.688 469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.688 469H243.312C237.617 469 233 473.617 233 479.312V502.688C233 508.383 237.617 513 243.312 513H266.688C272.383 513 277 508.383 277 502.688V479.312C277 473.617 272.383 469 266.688 469Z",
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.748 506.415H269.779C269.961 506.415 270.136 506.342 270.265 506.213C270.394 506.084 270.466 505.91 270.466 505.727L270.469 495.098C270.469 489.543 269.272 485.272 262.779 485.272C260.311 485.181 257.984 486.453 256.728 488.577C256.722 488.588 256.713 488.596 256.702 488.6C256.69 488.605 256.678 488.605 256.667 488.602C256.655 488.599 256.645 488.592 256.637 488.583C256.63 488.573 256.626 488.562 256.626 488.55V486.473C256.626 486.29 256.554 486.116 256.425 485.987C256.296 485.858 256.121 485.785 255.938 485.785H251.164C250.982 485.785 250.807 485.858 250.678 485.987C250.549 486.116 250.477 486.29 250.477 486.473V505.726C250.477 505.909 250.549 506.083 250.678 506.212C250.807 506.341 250.982 506.414 251.164 506.414H256.195C256.377 506.414 256.552 506.341 256.681 506.212C256.81 506.083 256.882 505.909 256.882 505.726V496.209C256.882 493.518 257.393 490.912 260.729 490.912C264.018 490.912 264.06 493.991 264.06 496.383V505.727C264.06 505.909 264.133 506.084 264.262 506.213C264.391 506.342 264.566 506.415 264.748 506.415ZM239.531 479.248C239.531 481.288 241.21 482.966 243.249 482.966C245.288 482.965 246.966 481.286 246.966 479.248C246.965 477.209 245.288 475.531 243.249 475.531C241.209 475.531 239.531 477.209 239.531 479.248ZM240.727 506.415H245.764C245.947 506.415 246.122 506.342 246.251 506.213C246.38 506.084 246.452 505.909 246.452 505.727V486.473C246.452 486.29 246.38 486.116 246.251 485.987C246.122 485.858 245.947 485.785 245.764 485.785H240.727C240.545 485.785 240.37 485.858 240.241 485.987C240.112 486.116 240.04 486.29 240.04 486.473V505.727C240.04 505.909 240.112 506.084 240.241 506.213C240.37 506.342 240.545 506.415 240.727 506.415Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    transform: "translate(392 560)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418.79 570.913V578.444L421.425 580.101C421.52 580.122 421.618 580.122 421.713 580.101L433.041 572.464C433.032 572.094 432.897 571.737 432.657 571.455C432.416 571.172 432.086 570.981 431.722 570.913H418.79Z",
    fill: "#0072C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M418.79 581.253L421.193 582.903C421.305 582.972 421.434 583.008 421.566 583.008C421.698 583.008 421.827 582.972 421.939 582.903C421.527 583.152 433.04 575.509 433.04 575.509V589.349C433.07 589.63 433.038 589.914 432.947 590.18C432.856 590.447 432.708 590.691 432.512 590.895C432.317 591.099 432.08 591.257 431.817 591.36C431.554 591.462 431.272 591.506 430.991 591.488H418.789L418.79 581.253ZM406.355 577.782C405.956 577.78 405.564 577.886 405.22 578.089C404.876 578.291 404.594 578.583 404.402 578.934C403.88 579.862 403.629 580.919 403.679 581.984C403.625 583.046 403.876 584.101 404.402 585.025C404.593 585.361 404.868 585.641 405.201 585.837C405.534 586.032 405.913 586.137 406.299 586.14C406.685 586.143 407.065 586.044 407.401 585.854C407.737 585.664 408.017 585.388 408.213 585.055C408.733 584.136 408.979 583.086 408.921 582.03C408.98 580.942 408.743 579.858 408.233 578.894C408.051 578.555 407.78 578.272 407.449 578.076C407.118 577.88 406.74 577.778 406.355 577.782Z",
    fill: "#0072C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M394.96 567.088V596.55L417.372 601.25V562.75L394.96 567.088ZM409.958 586.8C409.539 587.391 408.982 587.871 408.335 588.197C407.688 588.523 406.97 588.686 406.246 588.671C405.54 588.684 404.841 588.526 404.209 588.21C403.577 587.895 403.03 587.431 402.616 586.859C401.633 585.487 401.141 583.824 401.22 582.138C401.137 580.369 401.637 578.622 402.645 577.166C403.069 576.563 403.636 576.075 404.294 575.743C404.952 575.411 405.681 575.246 406.418 575.263C407.119 575.248 407.813 575.407 408.439 575.723C409.064 576.04 409.603 576.506 410.007 577.079C410.98 578.481 411.463 580.165 411.382 581.869C411.467 583.625 410.967 585.36 409.958 586.8Z",
    fill: "#0072C6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_3491_2725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.939 32.7367C153.938 36.4336 154.911 40.0433 156.762 43.2249L153.762 54.0956L164.973 51.1787C168.074 52.8538 171.549 53.7315 175.08 53.7317H175.089C186.745 53.7317 196.233 44.3206 196.238 32.7532C196.24 27.148 194.042 21.8772 190.049 17.9118C186.056 13.9467 180.746 11.7618 175.088 11.7593C163.431 11.7593 153.944 21.1698 153.939 32.7367",
    fill: "url(#paint2_linear_3491_2725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.184 32.7299C153.183 36.5597 154.191 40.2985 156.108 43.5941L153 54.8545L164.614 51.833C167.814 53.5642 171.417 54.4769 175.083 54.4783H175.092C187.166 54.4783 196.995 44.7287 197 32.7473C197.002 26.9406 194.725 21.4804 190.589 17.3728C186.453 13.2658 180.953 11.0024 175.092 11C163.016 11 153.189 20.7482 153.184 32.7299ZM160.1 43.0265L159.667 42.3435C157.844 39.4675 156.881 36.144 156.883 32.7312C156.887 22.7724 165.055 14.6701 175.099 14.6701C179.963 14.6721 184.534 16.5535 187.972 19.9671C191.41 23.3811 193.302 27.9192 193.301 32.7459C193.297 42.7047 185.128 50.8081 175.092 50.8081H175.085C171.817 50.8064 168.612 49.9356 165.817 48.29L165.152 47.8986L158.26 49.6915L160.1 43.0264V43.0265Z",
    fill: "url(#paint3_linear_3491_2725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.616 23.6453C169.206 22.741 168.775 22.7227 168.385 22.7069C168.065 22.6932 167.7 22.6942 167.336 22.6942C166.971 22.6942 166.377 22.8305 165.876 23.3737C165.374 23.9174 163.96 25.2312 163.96 27.9035C163.96 30.5759 165.922 33.1584 166.195 33.5211C166.469 33.8832 169.982 39.5425 175.546 41.7196C180.17 43.5289 181.111 43.1691 182.115 43.0783C183.118 42.988 185.353 41.7648 185.809 40.4965C186.266 39.2283 186.266 38.1413 186.129 37.9141C185.992 37.6878 185.627 37.5519 185.08 37.2804C184.532 37.0087 181.841 35.6947 181.339 35.5134C180.837 35.3323 180.472 35.2419 180.107 35.7858C179.742 36.3288 178.694 37.5519 178.374 37.9141C178.055 38.2772 177.736 38.3224 177.188 38.0507C176.641 37.7782 174.878 37.2054 172.786 35.3551C171.159 33.9154 170.06 32.1375 169.741 31.5937C169.422 31.0507 169.707 30.7563 169.981 30.4856C170.227 30.2423 170.529 29.8514 170.803 29.5344C171.076 29.2171 171.167 28.9908 171.349 28.6286C171.532 28.266 171.441 27.9488 171.304 27.6771C171.167 27.4055 170.103 24.7193 169.616 23.6453Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.871 8.00896C464.871 12.2153 464.871 16.4218 464.871 20.6281C469.911 20.6281 474.95 20.6281 479.989 20.6281C480.018 32.4347 479.989 44.2411 479.903 56.0476C479.417 57.2188 478.472 58.0074 477.069 58.4137C464.356 58.5093 451.643 58.5093 438.93 58.4137C437.527 58.0074 436.583 57.2188 436.096 56.0476C435.925 40.6959 435.982 25.3522 436.268 10.0165C436.837 9.06313 437.725 8.41784 438.93 8.08066C447.577 8.00896 456.224 7.98506 464.871 8.00896Z",
    fill: "#2583FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.875 8.00562C469.972 12.1642 475.011 16.3705 479.993 20.6247C474.954 20.6247 469.914 20.6247 464.875 20.6247C464.875 16.4184 464.875 12.2119 464.875 8.00562Z",
    fill: "#0066DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.625 27.5085C453.871 27.5085 462.117 27.5085 470.363 27.5085C470.363 28.4646 470.363 29.4205 470.363 30.3765C462.117 30.3765 453.871 30.3765 445.625 30.3765C445.625 29.4205 445.625 28.4646 445.625 27.5085Z",
    fill: "#FEFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.625 34.3948C453.871 34.3948 462.117 34.3948 470.363 34.3948C470.363 35.3508 470.363 36.3067 470.363 37.2628C462.117 37.2628 453.871 37.2628 445.625 37.2628C445.625 36.3067 445.625 35.3508 445.625 34.3948Z",
    fill: "#FEFFFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.625 41.2808C451.581 41.2808 457.536 41.2808 463.492 41.2808C463.492 42.2368 463.492 43.1927 463.492 44.1487C457.536 44.1487 451.581 44.1487 445.625 44.1487C445.625 43.1927 445.625 42.2368 445.625 41.2808Z",
    fill: "#FEFFFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3491_2725",
    x1: 270.793,
    y1: 321.34,
    x2: 301.814,
    y2: 318.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3491_2725",
    x1: 315.689,
    y1: 327.93,
    x2: 339.29,
    y2: 325.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3491_2725",
    x1: 2277.56,
    y1: 4245.4,
    x2: 2277.56,
    y2: 11.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3491_2725",
    x1: 2353,
    y1: 4396.45,
    x2: 2353,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3491_2725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 66,
    fill: "white",
    transform: "translate(255 267)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3491_2725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(585 238)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3491_2725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 29.3333,
    fill: "white",
    transform: "translate(0 390)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3491_2725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(102 215)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3491_2725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 36.6667,
    fill: "white",
    transform: "translate(471 353)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3491_2725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(233 469)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_3491_2725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(153 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteWizAlternative);
export default __webpack_public_path__ + "static/media/WriteWizAlternative.a16690e36df1cf34c02c9c7b16026456.svg";
export { ForwardRef as ReactComponent };